/* Підписи інтерфейсу, українська. Правиться руками.
 *
 * Машинний переклад без вичитки носієм — див. звіт до задачі.
 */

export const ui_uk = {
  // загальне, трапляється на кількох екранах
  'ui.common.loading': 'Завантаження...',
  'ui.common.continue': 'Продовжити',
  'ui.common.check': 'Перевірити',
  'ui.common.seeResults': 'Переглянути результати',
  'ui.common.myProgress': 'Мій прогрес',
  'ui.common.startTraining': 'Почати навчання',
  'ui.common.min': 'хв',

  // інструктор
  'ui.alisa.name': 'Аліса',
  'ui.alisa.initial': 'А',

  // нижня навігація
  'ui.nav.home': 'Головна',
  'ui.nav.modules': 'Модулі',
  'ui.nav.progress': 'Прогрес',
  'ui.nav.profile': 'Профіль',

  // заставка та знайомство
  'ui.splash.tagline': 'Перший день на лінії',
  'ui.splash.cardTitle': 'Інтерактивний тренажер',
  'ui.splash.cardText':
    'Пройди навчання з віртуальним інструктором Алісою. Відпрацьовуй реальні ситуації в безпечному середовищі та підготуйся до першого дня на роботі. Це займе лише близько 5 хвилин!',
  'ui.splash.start': 'Почати',
  'ui.splash.imAlisa': 'Я Аліса',
  'ui.splash.yourName': 'Як тебе звати?',
  'ui.splash.introducePrompt': 'Назви своє ім’я, і ми почнемо навчання',
  'ui.splash.namePlaceholder': 'Введи своє ім’я',

  // головний екран
  'ui.home.badgeLine1': 'Перший день',
  'ui.home.badgeLine2': 'на лінії',
  'ui.home.welcome': 'Ласкаво просимо,',
  'ui.home.ctaContinue': 'Продовжити навчання',
  'ui.home.ctaRetake': 'Повторити навчання',
  'ui.home.ctaStart': 'Почати навчання',
  'ui.home.settings': 'Налаштування',
  'ui.home.modulesDone': '{done}/{total} модулів пройдено',

  // список модулів
  'ui.modules.title': 'Модулі',
  'ui.modules.subtitle': 'Обери тему для навчання',

  // навчальний матеріал
  'ui.learning.notFound': 'Навчальний матеріал не знайдено',
  'ui.learning.label': 'Навчальний матеріал',
  'ui.learning.alisaHint': 'Прочитай матеріал перед проходженням тесту. Тут зібрано все найважливіше!',
  'ui.learning.contents': 'Зміст',
  'ui.learning.doneTitle': 'Матеріал вивчено!',
  'ui.learning.doneSubtitle': 'Тепер перевір свої знання в інтерактивному тесті',
  'ui.learning.goToTest': 'Перейти до тесту',
  'ui.learning.startTest': 'Почати тест',

  // проходження модуля
  'ui.module.title': 'Модуль 1: {title}',
  'ui.module.notFound': 'Модуль не знайдено',
  'ui.module.leaveConfirm': 'Ти впевнений, що хочеш вийти? Прогрес буде збережено.',
  'ui.module.voiceOn': 'Озвучення увімкнено',
  'ui.module.voiceOff': 'Озвучення вимкнено',
  'ui.module.voiceUnavailable': 'Озвучення недоступне в демоверсії',

  // результати
  'ui.results.moduleComplete': 'Модуль «{title}» завершено',
  'ui.results.statusExcellent': 'Відмінно!',
  'ui.results.statusGood': 'Добре!',
  'ui.results.statusFair': 'Задовільно',
  'ui.results.statusMoreTraining': 'Потрібне додаткове навчання',
  'ui.results.recPerfect':
    'Ти чудово підготувався до першого робочого дня! Усі відповіді правильні. Ти готовий до роботи на лінії!',
  'ui.results.recDecent':
    'Непоганий результат! Зверни увагу на помилки та спробуй ще раз, щоб закріпити матеріал.',
  'ui.results.recRetake':
    'Раджу пройти модуль заново. Уважно читай кожну ситуацію та звертай увагу на підказки.',
  'ui.results.time': 'Час',
  'ui.results.mistakes': 'Помилок',
  'ui.results.points': 'Балів',
  'ui.results.breakdown': 'Деталізація балів',
  'ui.results.advice': 'Рекомендація Аліси',
  'ui.results.tryAgain': 'Пройти заново',
  'ui.results.backToMenu': 'Повернутися в меню',
  'ui.results.metric.Safety': 'Безпека',
  'ui.results.metric.Service': 'Сервіс',
  'ui.results.metric.Efficiency': 'Ефективність',
  'ui.results.metric.Professionalism': 'Професіоналізм',
  'ui.results.metric.StressResistance': 'Стресостійкість',

  // прогрес
  'ui.progress.title': 'Прогрес',
  'ui.progress.subtitle': 'Твої досягнення та історія навчання',
  'ui.progress.completed': 'Пройдено',
  'ui.progress.totalPoints': 'Усього балів',
  'ui.progress.overall': 'Загальний прогрес',
  'ui.progress.history': 'Історія проходжень',
  'ui.progress.empty': 'Ти ще не пройшов жодного модуля',
  'ui.progress.unknownModule': 'Невідомий модуль',
  'ui.progress.gradeGreat': 'Відмінно',
  'ui.progress.gradeGood': 'Добре',
  'ui.progress.gradeRetake': 'Повторити',
  'ui.progress.pts': 'б.',

  // профіль
  'ui.profile.role': 'Кур’єр-стажист',
  'ui.profile.statModules': 'Модулів',
  'ui.profile.statTime': 'Час',
  'ui.profile.statBest': 'Рекорд',
  'ui.profile.logout': 'Вийти з акаунта',
  'ui.profile.logoutConfirm': 'Ти впевнений? Увесь прогрес буде видалено.',

  // посилання назовні: сайт агенції та запис на дзвінок
  'ui.cta.site': 'Зроблено в BrilliantFlux',
  'ui.cta.booking': 'Записатися на дзвінок',

  // вкладка браузера
  'ui.meta.title': 'Delivery Ace | Тренажер',
  'ui.meta.description': 'Інтерактивний тренажер для кур’єрів доставки',
};
